import {
  SERVICE_PROVIDERS,
  EspAccount,
  EmailEspAccount,
  EspAccountWithCustomMTAConfig,
  SmsEspAccount,
  WhatsAppEspAccount,
} from 'modules/graphql/types';

export const mockSparkpostAccount: EmailEspAccount = {
  id: 124,
  name: 'My SparkPost Account',
  binding: 'marketing',
  truncatedApiKey: '1857',
  customApiEndpoint: 'https://mydomain.sparkpost.com',
  isDefault: false,
  esp: SERVICE_PROVIDERS.SPARKPOST,
  projectId: 1,
};

export const mockSparkpostEliteAccount: EmailEspAccount = {
  id: 523,
  name: 'My SparkPost Elite Account',
  binding: 'transactional',
  truncatedApiKey: '6392',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.SPARKPOST_ELITE,
  projectId: 1,
};

export const mockSparkpostEUEliteAccount: EmailEspAccount = {
  id: 312,
  name: 'My SparkPost EU Account',
  binding: 'marketing',
  truncatedApiKey: '5823',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.SPARKPOST_EU,
  projectId: 1,
};

export const mockMailgunAccount: EmailEspAccount = {
  id: 649,
  name: 'My MailGun Account',
  binding: null,
  truncatedApiKey: '7743',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.MAILGUN,
  projectId: 1,
};

export const mockMailgunEUAccount: EmailEspAccount = {
  id: 649,
  name: 'My MailGunEU Account',
  binding: null,
  truncatedApiKey: '7743',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.MAILGUN_EU,
  projectId: 1,
};

export const mockDynAccount: EmailEspAccount = {
  id: 433,
  name: 'My Dyn Account',
  binding: null,
  truncatedApiKey: '1123',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.DYN,
  projectId: 1,
};

export const mockSendgridAccount: EmailEspAccount = {
  id: 312,
  name: 'My Sendgrid Account',
  binding: null,
  truncatedApiKey: '5252',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.SENDGRID,
  projectId: 1,
};

export const mockCustomEmailAccount: EspAccountWithCustomMTAConfig = {
  id: 378,
  name: 'My Custom Email Account',
  binding: null,
  truncatedApiKey: '5252',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.CUSTOM_MTA,
  customMTAConfig: {
    apiEndpoint: 'https://mydomain.sparkpost.com',
    authParams: {
      clientId: '123',
      clientSecret: '123',
      tokenEndpoint: 'https://mydomain.sparkpost.com/oauth/token',
    },
    authType: 'OAuth2',
    customHeaders: {
      'X-My-Header': 'my-value',
    },
    id: 543,
    name: 'My Custom MTA Config',
  },
  projectId: 1,
};

export const mockCustomPushAccount: EspAccountWithCustomMTAConfig = {
  id: 552,
  name: 'My Custom Push ESP Account',
  binding: null,
  truncatedApiKey: '4893',
  customApiEndpoint: null,
  isDefault: false,
  esp: SERVICE_PROVIDERS.CUSTOM_MTA,
  customMTAConfig: {
    id: 412,
    name: 'Custom MTA Config for Push',
    apiEndpoint: 'https://mydomain.sparkpost.com',
    authParams: {
      clientId: '1539',
      clientSecret: '5123',
      tokenEndpoint: 'https://mydomain.sparkpost.com/oauth/token',
    },
    authType: 'OAuth2',
    customHeaders: {
      'X-My-Header': 'my-value',
    },
  },
  projectId: 1,
};

export const mockTelnyxAccount: SmsEspAccount = {
  id: 676,
  name: 'My Telnyx Account',
  binding: null,
  truncatedApiKey: '6923',
  customApiEndpoint: null,
  signingSecretPrefix: '6623',
  isDefault: false,
  esp: SERVICE_PROVIDERS.TELNYX,
  projectId: 1,
};

export const mockTwilioAccount: SmsEspAccount = {
  id: 789,
  name: 'My Twilio Account',
  binding: null,
  truncatedApiKey: '4183',
  customApiEndpoint: 'ACACACACACACACACACACACACACACACACAH',
  isDefault: false,
  esp: SERVICE_PROVIDERS.TWILIO,
  projectId: 1,
};

export const mockIterableSmsTelnyxAccount: SmsEspAccount = {
  ...mockTelnyxAccount,
  isSenderIterable: true,
};

export const mockIterableSmsTwilioAccount: SmsEspAccount = {
  ...mockTwilioAccount,
  isSenderIterable: true,
};

export const mockInfobipAccount: WhatsAppEspAccount = {
  esp: SERVICE_PROVIDERS.INFOBIP,
  id: 4,
  name: 'test',
  truncatedApiKey: '1234',
  binding: null,
  customApiEndpoint: null,
  isDefault: true,
  projectId: 2,
  senders: [
    {
      id: 1,
      displayName: 'jaspers market',
      phoneNumber: '5555555555',
      about: 'shopping and retail',
      email: 'about@jaspermarket.com',
      websites: ['www.jaspersmarket.com'],
      address: '123 fake st',
      description: 'A Jasper themed store',
      vertical: 'shopping',
    },
  ],
};

export const mockEspAccounts: EspAccount[] = [
  mockMailgunAccount,
  mockSparkpostAccount,
  mockCustomEmailAccount,
  mockTwilioAccount,
  mockInfobipAccount,
];
